import { useQuery } from '@tanstack/react-query'

import type { CalculateLoanRequest } from 'aem-libs-api/src/services/building-savings-product/v1/types'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'
import { apiRequest } from 'aem-libs-react-ts/src/services/apiRequest'

import { FIXATION_DEFAULT, MONTHS_IN_YEAR, QUERY_CACHE } from '../constants'
import { burinkaApi } from '../services/apiServices'
import { type LoansConsolidationInputType, loansConsolidationStore } from '../store'
import type { LoansConsolidationParams } from '../types'

const calculateLoanConsolidation = apiRequest(burinkaApi.calculateLoan, {
  skipFirstTracking: true,
  trackResponse: true
})

export const useBurinkaLoanConsolidationQuery = () => {
  const values = loansConsolidationStore.useStoreData()
  const params = useDynamicParams<LoansConsolidationParams>()
  const mapRequest = (values: LoansConsolidationInputType): CalculateLoanRequest => ({
    loanAmount: values.loanAmount + values.extraLoanAmount,
    installmentCount: values.loanDuration * MONTHS_IN_YEAR,
    fixation: params.fixation ? params.fixation * MONTHS_IN_YEAR : FIXATION_DEFAULT,
    productId: params.productId,
    rating: 1,
    insuranceType: null
  })
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_CACHE.CALC_RESPONSE, values.loanAmount, values.loanDuration, values.extraLoanAmount],
    queryFn: async () => calculateLoanConsolidation(mapRequest(values)),
    placeholderData: (r) => r
  })

  return {
    response: data?.data,
    isFetching
  }
}
